import React from "react"
import styled from "styled-components"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import LinkedInIcon from "../../../assets/svgs/linked.svg"
import EmailIcon from "../../../assets/svgs/mail.svg"
import PhoneIcon from "../../../assets/svgs/phone.svg"
import SupervisorMask from "../../../images/open-positions/supervisor_mask.svg"
import { StaticImage } from "gatsby-plugin-image"

const StyledLink = styled.a`
  .gatsby-image-wrapper {
    height: 24px;
    width: 24px;
  }
  display: inline-block;
`

const SupervisorInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
`

const Testimontal = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  @media (min-width: 40em) {
    margin-top: auto;
  }
`

const SupervisorParagraph = styled.p`
  font-style: normal;
  font-family: var(--ff-primary);
  font-weight: 400;
  font-size: 0.625em;
  text-align: left;
  color: var(--clr-text-blue);
  line-height: 15px;
  letter-spacing: 0.004em;
`

const SupervisorName = styled.div`
  font-size: 0.75em;
  font-family: var(--ff-primary);
  font-weight: 700;
  color: var(--clr-text-blue);
  line-height: 18px;
  letter-spacing: 0.0015em;
`
const SocialContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 7px;
  margin-top: 16px;
  margin-bottom: 4px;

  svg {
    width: 24px;
    height: 24px;
  }
`

const Image = styled(GatsbyImage)`
  mask-image: url(${SupervisorMask});
  mask-size: contain;
  position: absolute !important;
  bottom: -26px;
  right: 5px;
  width: 105px;
  height: 105px;
  box-shadow: 0px 2px 4px 2px rgba(0, 0, 0, 0.25);

  img {
    object-fit: none !important;
    object-position: ${({ objectPosition }) =>
      objectPosition || "50% 10%"} !important;
  }
  @media (max-width: 20em) {
    right: 10px;
  }
`

const Supervisor = ({ image, supervisor }) => {
  const objectPosition =
    supervisor === "rami"
      ? "50% 0%"
      : supervisor === "tanja"
      ? "50% 20%"
      : undefined

  return (
    <Testimontal>
      <SupervisorInfo>
        <SupervisorParagraph>Your future growth enabler</SupervisorParagraph>
        {supervisor === "tanja" && (
          <>
            <SocialContainer>
              <>
                <StyledLink
                  aria-label="Chat on WhatsApp"
                  href={`https://wa.me/+358405182663`}
                  target="_blank"
                  rel="noreferrer"
                >
                  <StaticImage
                    src="../../../images/common/whatsapp_logo_green.png"
                    alt=""
                  />
                </StyledLink>
                <a href={`tel:+358503400701`} title="+358503400701">
                  <PhoneIcon />
                </a>
              </>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.linkedin.com/in/tanjalankia/"
                title="LinkedIn"
              >
                <LinkedInIcon />
              </a>
              <a
                href="mailto:tanja.lankia@rebase.fi"
                title="tanja.lankia@rebase.fi"
              >
                <EmailIcon />
              </a>
            </SocialContainer>
            <SupervisorName>Tanja Lankia</SupervisorName>
            <SupervisorParagraph>Head of Growth</SupervisorParagraph>
          </>
        )}
        {supervisor === "juhana" && (
          <>
            <SocialContainer>
              <>
                <StyledLink
                  aria-label="Chat on WhatsApp"
                  href={`https://wa.me/+358405182663`}
                  target="_blank"
                  rel="noreferrer"
                >
                  <StaticImage
                    src="../../../images/common/whatsapp_logo_green.png"
                    alt=""
                  />
                </StyledLink>
                <a href={`tel:+358405182663`} title="+358405182663">
                  <PhoneIcon />
                </a>
              </>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.linkedin.com/in/juhanahuotarinen/"
                title="LinkedIn"
              >
                <LinkedInIcon />
              </a>
              <a
                href="mailto:juhana.huotarinen@rebase.fi"
                title="juhana.huotarinen@rebase.fi"
              >
                <EmailIcon />
              </a>
            </SocialContainer>
            <SupervisorName>Juhana Huotarinen</SupervisorName>
            <SupervisorParagraph>CEO, Co-founder</SupervisorParagraph>
          </>
        )}
        {supervisor === "tuuli" && (
          <>
            <SocialContainer>
              <>
                <StyledLink
                  aria-label="Chat on WhatsApp"
                  href={`https://wa.me/+358408285922`}
                  target="_blank"
                  rel="noreferrer"
                >
                  <StaticImage
                    src="../../../images/common/whatsapp_logo_green.png"
                    alt=""
                  />
                </StyledLink>
                <a href={`tel:+358408285922`} title="+358408285922">
                  <PhoneIcon />
                </a>
              </>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.linkedin.com/in/tuulimansikka/"
                title="LinkedIn"
              >
                <LinkedInIcon />
              </a>
              <a
                href="mailto:tuuli.mansikkasalo@rebase.fi"
                title="tuuli.mansikkasalo@rebase.fi"
              >
                <EmailIcon />
              </a>
            </SocialContainer>
            <SupervisorName>Tuuli Mansikkasalo</SupervisorName>
            <SupervisorParagraph>Head of Growth</SupervisorParagraph>
          </>
        )}
        {supervisor === "rami" && (
          <>
            <SocialContainer>
              <>
                <StyledLink
                  aria-label="Chat on WhatsApp"
                  href={`https://wa.me/+358407611746`}
                  target="_blank"
                  rel="noreferrer"
                >
                  <StaticImage
                    src="../../../images/common/whatsapp_logo_green.png"
                    alt=""
                  />
                </StyledLink>
                <a href={`tel:+358407611746`} title="++358407611746">
                  <PhoneIcon />
                </a>
              </>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.linkedin.com/in/ramilaakso/"
                title="LinkedIn"
              >
                <LinkedInIcon />
              </a>
              <a
                href="mailto:rami.laakso@rebase.fi"
                title="rami.laakso@rebase.fi"
              >
                <EmailIcon />
              </a>
            </SocialContainer>
            <SupervisorName>Rami Laakso</SupervisorName>
            <SupervisorParagraph>Head of Growth</SupervisorParagraph>
          </>
        )}
      </SupervisorInfo>
      <Image
        alt="supervisor"
        image={getImage(image)}
        objectPosition={objectPosition}
      />
    </Testimontal>
  )
}

export default Supervisor
